import axios from 'axios'

export default function (config) {
  const supplierStore = {
    namespaced: true,
    state: {
      supplier: null,
      shops: null,
      inventories: []
    },
    mutations: {
      set (state, properties) {
        properties = properties || {}
        state.supplier = properties.supplier
        state.shops = properties.shops
      },
      setSupplier (state, supplier) {
        state.supplier = supplier
      },
      setImage (state, data) {
        state.supplier.photos[data.size] = data.url
      },
      setShops (state, shops) {
        state.shops = shops
      },
      updateShop (state, shop) {
        state.shops.some((oldShop, index) => {
          if (oldShop.id === shop.id) {
            state.shops.splice(index, 1, shop)
            return true
          }
        })
      },
      updateInventoryList (state, inventories) {
        state.inventories = inventories
      }
    },
    actions: {
      getSupplier (context, user) {
        if (!user) {
          context.commit('set', null)
        } else {
          return context.dispatch('auth/getAccessToken', null, { root: true })
            .then(accessToken => {
              return axios.get(`${config.API_URL}/suppliers/${user.supplierId}`, {
                params: {
                  includeAccounts: true,
                  includeShops: true
                },
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
              })
            }).then(result => {
              context.commit('setSupplier', result.data)
              context.dispatch('getShops', user)
              context.dispatch('getInventories')
            })
        }
      },
      getShops (context, user) {
        if (!user) {
          context.commit('set', null)
        } else {
          return context.dispatch('auth/getAccessToken', null, { root: true }).then(accessToken => {
            return axios.get(`${config.API_URL}/suppliers/${user.supplierId}/shops`, {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }).then(result => {
              context.commit('setShops', result.data)
            })
          })
        }
      },
      toggleShopStatus (context, shop) {
        return context.dispatch('auth/getAccessToken', null, { root: true }).then(accessToken => {
          return axios.post(`${config.API_URL}/suppliers/${context.state.supplier.code}/shops/${shop.id}/toggle`, {
            active: !shop.active
          }, {
            headers: {
              'Authorization': `Bearer ${accessToken}`
            }
          }).then(result => {
            shop.active = !shop.active
            context.commit('updateShop', shop)
          })
        })
      },
      getInventories (context) {
        if (!context.state.supplier) {
          return
        }

        return context.dispatch('auth/getAccessToken', null, { root: true }).then(accessToken => {
          return axios.get(`${config.API_URL}/suppliers/${context.state.supplier.id}/inventories`, {
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          }).then(result => {
            context.commit('updateInventoryList', result.data)
            return result.data
          })
        })
      },
      setImage ({commit}, data) {
        commit('setImage', data)
      }
    }
  }

  return supplierStore
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js